import { createActionGroup, props } from '@ngrx/store';

export const I18nActions = createActionGroup({
  source: 'I18n',
  events: {
    'Set Locale': props<{ locale: string }>(),
    'Set Locale Success': props<{ locale: string }>(),
    'Set Locale Failure': props<{ error: string }>(),
  },
});
